export default __webpack_public_path__ + "static/media/Helm of the Renegade.c0b89112.jpg";